export default __webpack_public_path__ + "static/plans-for-ehe-b027981451f1e77bb98b9201ae172169.svg";